import inputsPage from './inputs.vue';
import attributesPage from './attributes/attribute-editor.vue';
import competitorMatchesPage from './competitor-matches/competitor-matches.vue';
import engineInputsPage from './engine-inputs/engine-inputs.vue';
import priceOverridesPage from './price-overrides/price-overrides.vue';
import anchorMarginsPage from './anchor-margins/margins-container.vue';
import cdtHierarchiesPage from './hierarchies/cdt-hierarchies.vue';
import { inputs as inputsPageIndex } from '@enums/page-index';

import {
  enableInputsOverridePage,
  enableAnchorMarginsModule,
  enableCDTHierarchies,
} from '@enums/feature-flags';

const routes = [
  {
    path: '/inputs',
    name: 'inputs',
    id: 'inputs',
    component: inputsPage,
    linkText: 'linkText.inputs',
    index: inputsPageIndex,
    children: [
      {
        path: 'attributes/workpackage/:workpackageId',
        name: 'attributes',
        id: 'attributes',
        component: attributesPage,
        linkText: 'linkText.attributes',
        index: 0,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.attributes',
        },
      },
      {
        path: 'competitor-matches/workpackage/:workpackageId',
        name: 'competitor-matches',
        id: 'competitor-matches',
        component: competitorMatchesPage,
        linkText: 'linkText.competitorMatches',
        index: 1,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.competitorMatches',
        },
      },
      {
        path: 'engine-inputs/workpackage/:workpackageId',
        name: 'engine-inputs',
        id: 'engine-inputs',
        component: engineInputsPage,
        linkText: 'linkText.engineInputs',
        index: 2,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.engineInputs',
        },
      },
      {
        path: 'price-overrides/workpackage/:workpackageId',
        name: 'price-overrides',
        id: 'price-overrides',
        component: priceOverridesPage,
        linkText: 'linkText.priceOverrides',
        index: 3,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.priceOverrides',
          featureFlag: enableInputsOverridePage,
        },
      },
      {
        path: 'anchor-margins/workpackage/:workpackageId',
        name: 'anchor-margins',
        id: 'anchor-margins',
        component: anchorMarginsPage,
        linkText: 'linkText.anchorMargins',
        index: 4,
        meta: {
          featureFlag: enableAnchorMarginsModule,
          selectedWorkpackageRequired: true,
          title: 'tabText.anchorMargins',
        },
      },
      {
        path: 'cdtHierarchies/workpackage/:workpackageId',
        name: 'cdtHierarchies',
        id: 'cdtHierarchies',
        component: cdtHierarchiesPage,
        linkText: 'linkText.cdtHierarchies',
        index: 5,
        meta: {
          featureFlag: enableCDTHierarchies,
          selectedWorkpackageRequired: true,
          title: 'tabText.cdtHierarchies',
        },
      },
    ],
  },
];

export default routes;
